import { render, staticRenderFns } from "./CamposDinamicos.vue?vue&type=template&id=2b63ea62"
import script from "./CamposDinamicos.vue?vue&type=script&lang=js"
export * from "./CamposDinamicos.vue?vue&type=script&lang=js"
import style0 from "./CamposDinamicos.vue?vue&type=style&index=0&id=2b63ea62&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports